import { GeneralCard } from "../../../../components/Cards/GeneralCard";
import { PropertiesCard } from "../../../../components/Cards/PropertiesCard";
import { ProgressChart } from "../../../../components/CHARTS/Progress/ProgressChart";
import { Stepper } from "../../../../components/Stepper/Stepper";
import { CustomTag } from "../../../../components/Tags/CustomTag";
import { Tag } from "../../../../components/Tags/Tag";
import { ParentTree } from "../ParentTreeComponent/ParentTree";
import "./PartDetails.css";
import { getPartDetails } from "../../Services/PartsService";
import { useContext, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { PartDetailsDialog } from "./PartDetailsDialog";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import TimeControls from "../../../../components/TimeControls/TimeControls";
import PartTimeControlsDialog from "./PartTimeControlsDialog";
import timePlaceholder from "../../../../assets/Images/wait.png";
import ImagePlaceholder from "../../../../components/Placeholders/ImagePlaceholder";
import InventoryAvailabilityDialog from "./InventoryAvailabilityDialog";
import TransactionDialog from "./TransactionDialog";
import {
  getPartInfo,
  getPartLocationHistory,
  getPartPositionInformation,
  getInventoryAdditionalPartInfo,
  getPartTransacctionHistory,
  getTimeControlsByPart,
} from "../../Services/InventoryConfigurationService";
import { InventoryManagementContext } from "../../context/InventoryManagementContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { Checkbox } from '@mui/material';

export const PartDetails = ({ item, open }) => {
  const [partDetails, setPartDetails] = useState(null);
  const [unparseDetail, setUnparseDetail] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [locationDetails, setLocationDetails] = useState(null);

  const [positionDetails, setPositionDetails] = useState(null);
  const [timeControlsDetails, setTimeControlsDetails] = useState([]);
  const [transactionDetailsLoading, setTransactionDetailsLoading] =
    useState(true);
  const [generalInformationLoading, setGeneralInformationLoading] =
    useState(true);
  const [additionalPartInfo, setAdditionalPartInfo] = useState(null);
  const [locationDetailsLoading, setLocationDetailsLoading] = useState(true);
  const [timeControlsLoading, setTimeControlsLoading] = useState(true);
  const completed = useMemo(() => 4, []);
  const { setNavigateBatch } = useContext(InventoryManagementContext);
  const getTransactionIcon = (name) => {
    const icons = {
      OUT: "icon-outgoing",
      IN: "icon-incoming",
    };
    return icons[name] || "";
  };
  const navigateToOtherStep = (step) => {
    setNavigateBatch(step);
  };
  const perpareTimeControls = (timeControls) => {
    const controlDefinitions = [
      {
        type: "Hours",
        label: "Interval",
        percentField: "percentIntervalHours",
        maxField: "intervalHours",
        valueField: "actualHours",
      },
      {
        type: "Hours",
        label: "Threshold",
        percentField: "percentThresholdHours",
        maxField: "thresholdHours",
        valueField: "actualHours",
      },
      {
        type: "Hours",
        label: "TotalThreshold",
        percentField: "percentTotalThresholdHours",
        maxField: "thresholdTotalHours",
        valueField: "actualHours",
      },
      {
        type: "Cycles",
        label: "Interval",
        percentField: "percentIntervalCycles",
        maxField: "intervalCycles",
        valueField: "actualCycles",
      },
      {
        type: "Cycles",
        label: "Threshold",
        percentField: "percentThresholdCycles",
        maxField: "thresholdCycles",
        valueField: "actualCycles",
      },
      {
        type: "Cycles",
        label: "TotalThreshold",
        percentField: "percentTotalThresholdCycles",
        maxField: "thresholdTotalCycles",
        valueField: "actualCycles",
      },
      {
        type: "Days",
        label: "Interval",
        percentField: "percentIntervalDays",
        maxField: "intervalDays",
        valueField: "actualDays",
      },
      {
        type: "Days",
        label: "Threshold",
        percentField: "percentThresholdDays",
        maxField: "thresholdDays",
        valueField: "actualDays",
      },
      {
        type: "Days",
        label: "TotalThreshold",
        percentField: "percentTotalThresholdDays",
        maxField: "thresholdTotalDays",
        valueField: "actualDays",
      },
    ];

    const mapped = timeControls.map((element) => {
      let controls = [];

      controlDefinitions.forEach((def) => {
        const percent = element[def.percentField];
        const max = element[def.maxField];
        const value = element[def.valueField];

        if (percent > 0 && max != null && value != null) {
          controls.push({
            max,
            min: 0,
            value,
            remaining: max - value,
            name: `${def.label} ${def.type}`,
            percent,
          });
        }
      });

      // Ordenar los controles por el porcentaje
      controls.sort((a, b) => b.percent - a.percent);

      const maxPercent = controls.length > 0 ? controls[0].percent : 0;

      return {
        short_name: element.timeControlName,
        name: element.timeControlType,
        controls: controls.map(({ percent, ...rest }) => rest),
        maxPercent,
      };
    });

    // Ordenar los elementos por el maxPercent
    const sorted = mapped.sort((a, b) => b.maxPercent - a.maxPercent);

    // Eliminar maxPercent del resultado final
    return sorted.map(({ maxPercent, ...rest }) => rest);
  };

  useEffect(() => {
    if (open) {
      getPartInfo(item.partId)
        .then((response) => {
          setPartDetails(mapPartData(response.data.load));
          setUnparseDetail(response.data.load);
          setGeneralInformationLoading(false);
        })
        .catch((error) => setGeneralInformationLoading(false))
        .finally(() => {});
      if (item.type == "consumable") {
         getInventoryAdditionalPartInfo(
          null,
          item.internalBatch
        )
          .then((response) => {
            setAdditionalPartInfo(response.data.load);
          })
          .catch((error) => {});
        getPartLocationHistory(item.partId, item.internalBatch)
          .then((response) => {
            const formattedData = response.data.load;
            setLocationDetails(formattedData);
            setLocationDetailsLoading(false);
          })
          .catch((error) => setLocationDetailsLoading(false))
          .finally(() => {});
      } else {
        getInventoryAdditionalPartInfo(
          item.serializedPartId,
          item.internalBatch
        )
          .then((response) => {
            setAdditionalPartInfo(response.data.load);
          })
          .catch((error) => {});
        getPartPositionInformation(item.serializedPartId, item.aircraft_id)
          .then((response) => {
            if (response.data.load != null) {
              response.data.load.partPositionList?.reverse();
              setPositionDetails(response.data.load);
            }
          })
          .catch((error) => {
            setLocationDetailsLoading(false);
          })
          .finally(() => {});
        setLocationDetailsLoading(false);
      }
      if (item.serializedPartId != null) {
        getTimeControlsByPart(item.serializedPartId)
          .then((response) => {
            const formattedData = response.data.load;
            setTimeControlsDetails(perpareTimeControls(formattedData));
            setTimeControlsLoading(false);
          })
          .catch((error) => {
            setTimeControlsLoading(false);
            setTimeControlsDetails([]);
          })
          .finally(() => {});
      } else {
        setTimeControlsDetails([
          {
            name: "Shelf Life",
            short_name: "SHELF",
            controls: [
              {
                min: 1726161756,
                max: 1731432156,
                value: 1731832156,
                remaining: 1731432156 - 1731832156,
                name: "Days",
              },
            ],
          },
        ]);
        setTimeControlsLoading(false);
      }

      getPartTransacctionHistory(item.partId, item.internalBatch)
        .then((response) => {
          const formattedData = response.data.load
            .map((transaction) => ({
              ...transaction,
              transactionDate: dayjs(transaction.transactionDate).format(
                "YYYY-MM-DD HH:mm:ss A"
              ),
              icon: getTransactionIcon(transaction.transactionType), // Función para obtener el icono
            }))
            .toReversed();
          setTransactionDetails(formattedData);
          setTransactionDetailsLoading(false);
        })
        .catch((error) => setTransactionDetailsLoading(false))
        .finally(() => {});
    }
  }, [open]);

  return (
    <div className="card-grid">
      <GeneralCard
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <b>General</b>
            {item?.type && <CustomTag tag={item.type} />}
          </div>
        }
        tags={""}
        dialog={{
          component: PartDetailsDialog,
          props: { partDetail: unparseDetail, item: item, additionalPartInfo: additionalPartInfo },
        }}
      >
        {generalInformationLoading ? (
          <div className="item-container-loading-general-skeleton">
            <div className="item-general-container-skeleton">
              <Skeleton height={20} width="80%" />
              <Skeleton height={20} width="100%" />
            </div>
            <div className="item-general-container-body-skeleton">
              <div className="item-general-row-skeleton">
                <Skeleton height={20} width="80%" />
              </div>
              <div className="item-general-row-skeleton">
                <Skeleton height={20} width="80%" />
              </div>
              <div className="item-general-row-skeleton">
                <Skeleton height={20} width="80%" />
              </div>
              <div className="item-general-row-skeleton">
                <Skeleton height={20} width="80%" />
              </div>
              <div className="item-general-row-skeleton">
                <Skeleton height={20} width="80%" />
              </div>
            </div>
          </div>
        ) : (
          partDetails?.general && (
            <>
              <PropertiesCard object={partDetails?.general[0]} />
              <div className="general-card-ata">
                <b>ATA</b>
                <div className="general-card-ata-content">
                  <div className="general-card-ata-content-info">
                    <b>
                      {`${partDetails?.general?.[1]?.Chapter ?? "00"}-${
                        partDetails?.general?.[1]?.Section ?? "00"
                      }-${partDetails?.general?.[1]?.Paragraph ?? "00"}`}
                    </b>
                  </div>
                </div>
              </div>
            </>
          )
        )}
      </GeneralCard>
      <div>
        <GeneralCard
          title={<b>Location</b>}
          tags={""}
          dialog={{
            component: InventoryAvailabilityDialog,
            props: { partId: item.partId },
          }}
        >
          {locationDetailsLoading || generalInformationLoading ? (
            <div className="item-location-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-location-skeleton-content">
                <Skeleton height={20} width="80%" />
                <Skeleton height={20} width="30%" />
              </div>

              <Skeleton height={20} width="4rem" />
            </div>
          ) : item.type == "consumable" ? (
            <>
              <div className="consumable-card-container">
                <div className="consumable-card-info">
                  <i className="icon-stock"></i>
                  <div className="consumable-card-text">
                    <span>{item.location_code}</span>
                    <p>{`${locationDetails?.rackName}, ${
                      locationDetails?.shelfName ?? "N/A"
                    }, ${locationDetails?.binName ?? "N/A"}`}</p>
                  </div>
                </div>
                <b>
                  {item.QTY} {item.UOM}
                </b>
              </div>
            </>
          ) : (
            <div
              className={`main-part-card ${
                !positionDetails?.nhaPart || positionDetails.nhaPart == "--"
                  ? "oneGrid"
                  : ""
              }`}
            >
              {positionDetails?.nhaPart && positionDetails.nhaPart !== "--" ? (
                <>
                  <div className="installed-card-container">
                    <div className="installed-card" style={{ width: "100%" }}>
                      <div
                        className={`info-installed-card ${
                          item.status == "Installed" ? "installed-nha" : ""
                        }`}
                      >
                        <i className="icon-airplane-installed"></i>
                        <b>
                          {item.status == "Installed"
                            ? "Installed"
                            : "Not Installed"}
                        </b>
                      </div>
                      <div className="installed-card-info-row">
                        <span>{partDetails?.inventory?.installed.title} </span>
                        <b>{partDetails?.inventory?.installed.subtitle}</b>
                      </div>
                      <div className="installed-card-info-row">
                        <span> Type/series </span>
                        <b>
                          {positionDetails?.aircraftType &&
                          positionDetails?.aircraftSeries
                            ? `${positionDetails?.aircraftType} - ${positionDetails?.aircraftSeries}`
                            : "--"}
                        </b>
                      </div>
                    </div>
                  </div>
                  <PropertiesCard
                    object={
                      item.status === "Installed"
                        ? {
                            "Aircraft Position": partDetails?.inventory?.Bin,
                            "NHA PN/SN": (
                              <ParentTree data={positionDetails} item={item}>
                                {positionDetails?.nhaPart}
                              </ParentTree>
                            ),
                            "NLA Position":
                              positionDetails?.nlaPoistion ?? "--",
                          }
                        : {
                            Location: (
                              <p>
                                {partDetails?.inventory?.Bin.substring(
                                  partDetails?.inventory?.Bin.indexOf(",") + 1
                                ).trim()}
                              </p>
                            ),
                            "NHA PN/SN": (
                              <ParentTree data={positionDetails} item={item}>
                                {positionDetails?.nhaPart}
                              </ParentTree>
                            ),
                            "NLA Position":
                              positionDetails?.nlaPoistion ?? "--",
                          }
                    }
                  />
                </>
              ) : (
                <div
                  className={`installed-card-container ${
                    item.status === "Installed"
                      ? "installed-info"
                      : "not-installed"
                  }`}
                >
                  <div className="installed-card">
                    <div className="info-icon">
                      <i className="icon-airplane-installed"></i>
                      <span>
                        {partDetails?.inventory?.installed.title}{" "}
                        <b>{partDetails?.inventory?.installed.subtitle}</b>
                      </span>
                    </div>
                  </div>
                  {item.status === "Installed" ? (
                    <div className="installed-card-info">
                      <span>
                        Type/series{" "}
                        <b>
                          {positionDetails?.aircraftType}
                          {" - "}
                          {positionDetails?.aircraftSeries}
                        </b>
                      </span>
                      <span>
                        Postion <b>LH</b>
                      </span>
                    </div>
                  ) : (
                    <b className="location-name">
                      {" "}
                      {partDetails?.inventory?.Bin}
                    </b>
                  )}
                </div>
              )}
            </div>
          )}
        </GeneralCard>

        <GeneralCard
          title={
            <div className="transaction-history-title">
              <b>Transaction History</b>
              <div className="transaction-info">
                <div className="transaction-in">
                  <i className="icon-incoming"></i>
                  <p>Incoming/Receipts</p>
                </div>

                <div className="transaction-out">
                  <i className="icon-outgoing"></i>
                  <p>Outgoing/Dispatches</p>
                </div>
              </div>
            </div>
          }
          tags={""}
          dialog={{
            component: TransactionDialog,
            props: { partId: item.partId },
          }}
        >
          {transactionDetailsLoading ? ( // Mostrar esqueletos mientras carga
            Array.from({ length: 5 }).map((_, idx) => (
              <div key={idx} className="item-steper-container-skeleton">
                <Skeleton circle height="2.16rem" width="2.16rem" />
                <div className="item-steper-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
              </div>
            ))
          ) : (
            <>
              <Stepper
                steps={transactionDetails?.slice(-5)}
                item={item}
                currentStep={completed}
                navigateToOtherStep={navigateToOtherStep}
                recentFirst
              />
              {transactionDetails?.length <= 3 && (
                <div className="transaction-history-footer">
                  <i className="icon-info-text"></i>

                  <div className="transaction-history-footer-text">
                    <b>Limited transaction history.</b>
                    <p>
                      More records will appear here as they become available.
                    </p>
                  </div>
                </div>
              )}

              {transactionDetails?.length > 5 && (
                <div className="transaction-history-hover">
                  <div className="transaction-history-hover-header">
                    <div className="more-options-container">
                      <span>
                        <i className="icon-more-horizontal"></i>
                      </span>
                    </div>
                    <p>
                      Click the button in the upper left corner of the title to
                      access the complete transaction history.
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        </GeneralCard>
      </div>
      <GeneralCard
        title={<b>Time Controls</b>}
        tags={""}
        dialog={{
          component: PartTimeControlsDialog,
          props: { timeControlsDetails: timeControlsDetails ?? [] },
        }}
        disabled={timeControlsDetails.length <= 2}
      >
        {timeControlsDetails?.length > 0 ? (
          timeControlsDetails?.map((timeControl) => (
            <TimeControls
              note={
                timeControl.controls.some(
                  (control) => control.remaining <= 0
                ) ? (
                  <Tag tag="Overdue" type="error" aspect="transparent" />
                ) : (
                  ""
                )
              }
              showAsKeyValue={timeControl.short_name === "TSN"}
              isDate={timeControl.short_name === "SHELF"}
              key={timeControl.name}
              controls={timeControl.controls}
              name={timeControl.name}
              short_name={timeControl.short_name}
            />
          ))
        ) : (
          <ImagePlaceholder
            image={timePlaceholder}
            title={"No time controls available"}
            subtitle={""}
          />
        )}
      </GeneralCard>
    </div>
  );

  function mapPartData(rawData) {
    return {
      general: [
        {
          title: rawData.name,
          subtitle: `(${rawData.description})`,
          "PN Category": rawData.categoryName,
          "Sub Category": rawData.subCategoryName,
          GRN: item.Batch,
          UOM: item.uomName,
          Manufacturer: rawData.manufacturerName,
        },
        {
          title: "ATA",
          Chapter: rawData.aviationPart?.atachapterName ?? "00",
          Section: rawData.aviationPart?.atasectionName ?? "00",
          Paragraph: rawData.aviationPart?.ataparagraphName ?? "00",
        },
      ],
      owner: {
        Owner: rawData.manufacturerName,
        "Ownership Type": "",
      },
      time_controls:
        item.type === "part"
          ? []
          : [
              {
                name: "Shelf Life",
                short_name: "SHELF",
                controls: [
                  {
                    min: 1726161756,
                    max: 1731432156,
                    value: 1731832156,
                    remaining: 1731432156 - 1731832156,
                    name: "Days",
                  },
                ],
              },
            ],
      type: item.type,
      inventory: {
        Bin: item.status == "Installed" ? "LH" : item.location_name,
        "NHA PN/SN": "111-222-333/EN12345",
        "NLA Position": "Position Blade 5 in Blade Assembly",
        Location: item.location_name,
        installed: {
          title:
            item.status == "Installed" ? " Installed on" : " Not Installed",
          subtitle: item.status == "Installed" ? item.aircraft_name : "",
        },
      },
      lastTransactionIndex: 4,
    };
  }
};
